import { DEFAULT_LANG } from './constants.ts';
import type { Lang } from './enums.ts';

/** Maps Telegram `language_code` (e.g. "ru", "en-US") to an app language. */
export function resolveLang(languageCode: string | null | undefined): Lang {
  const base = languageCode?.toLowerCase().split(/[-_]/)[0];
  if (base === 'uz' || base === 'ru' || base === 'en') return base;
  return DEFAULT_LANG;
}
